// extracted by mini-css-extract-plugin
export default {"fab":"KioskFloatingCart_fab__7QAhQ","material-symbols-outlined":"KioskFloatingCart_material-symbols-outlined__e7zST","badge":"KioskFloatingCart_badge__wqM1c"};